import { Process } from 'common/types/security'
import { GoToSectionValues } from '../types'
import { LanguageValues } from 'common/types/instance'

type ProcessKey = keyof typeof Process

export const sectionPermissions: Record<string, ProcessKey[] | undefined> = {
  [GoToSectionValues.FILES]: ['list_folders'],
  [GoToSectionValues.CODE]: ['view_influence_diagram'],
  [GoToSectionValues.PROCESS]: ['manage_processes'],
  [GoToSectionValues.USERS]: ['list_users'],
  [GoToSectionValues.TEAMS]: ['add_team'],
  [GoToSectionValues.DEPARTMENTS]: ['view_department'],
  [GoToSectionValues.ROLES]: ['view_role'],
  [GoToSectionValues.COMPANIES]: ['list_companies'],
  [GoToSectionValues.PERMISSIONS_BY_ROLE]: ['view_permission'],
  [GoToSectionValues.LOGS]: ['view_company_logs'],
  [GoToSectionValues.INTERFACE_LINKS]: ['view_externallink'],
  [GoToSectionValues.API_ENDPOINTS]: ['view_externallink'],
  [GoToSectionValues.GENERAL_SETTINGS]: ['change_general_settings'],
  [GoToSectionValues.TASKS]: ['view_periodictask'],
  [GoToSectionValues.APPS]: ['view_applications'],
  [GoToSectionValues.INSTANCES]: ['list_instances', 'list_company_instances'],
  [GoToSectionValues.SCENARIO_MANAGER]: [
    'create_application_scenario',
    'update_application_scenario_properties',
    'delete_application_scenario'
  ],
  [GoToSectionValues.SCENARIO_TEMPLATES]: [
    'create_application_scenario',
    'update_application_scenario_properties',
    'delete_application_scenario'
  ],
  [GoToSectionValues.VERSIONS]: [
    'create_application_version',
    'update_application_version_properties',
    'update_application_version_status',
    'delete_application_version'
  ],
  [GoToSectionValues.APP_CONSOLIDATION]: ['consolidate_applications'],
  [GoToSectionValues.INTERFACES]: ['view_interface_manager']
}
export const getNoPermissionMessage = (language: LanguageValues, section: string): string => {
  const messages: Record<LanguageValues, string> = {
    'en-US': 'You do not have permission to go to {path}',
    'es-AR': 'No tienes permiso para ir a {path}',
    'pt-BR': 'Você não tem permissão para ir para {path}'
  }

  let lang = language
  if (!lang) {
    const navigatorLang = navigator.language.substring(0, 2)
    lang =
      (Object.keys(messages).find((l) => l.includes(navigatorLang)) as LanguageValues) ||
      LanguageValues.En
  }

  const template = messages[lang] || messages['en-US']
  return template.replace('{path}', section)
}
